export const API_URL = "https://api.budfem.com.ua"